import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Css/View.css";
import API_BASE from "../config/api";

const InstitudeEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [form, setForm] = useState({
    instituteName: "",
    principleName: "",
    address: "",
    email: "",
    phoneNumber: "",
    commissionPercentage: 0,
    isActive: true,
    softwareIds: []
  });

  const [allSoftwares, setAllSoftwares] = useState([]);
  const [teachersCount, setTeachersCount] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  /* ---------------- GET DATA ---------------- */
  useEffect(() => {
    loadInstitute();
    loadSoftwares();
  }, []);

  const loadInstitute = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/Institutes/${id}`
      );

      const data = res.data;

      setForm({
        instituteName: data.instituteName,
        principleName: data.principleName,
        address: data.address,
        email: data.email,
        phoneNumber: data.phoneNumber,
        commissionPercentage: data.commissionPercentage,
        isActive: data.isActive,
        softwareIds: data.softwares.map(x => x.id)
      });

      setTeachersCount(data.teachersCount);
    } catch (err) {
      alert("Institute load failed");
    }
  };

  const loadSoftwares = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/institutes/dropdown`
      );
      setAllSoftwares(res.data);
    } catch {
      alert("Software list load failed");
    }
  };

  /* ---------------- HANDLE CHANGE ---------------- */

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  /* ---------------- SOFTWARE SELECT ---------------- */

  const handleSoftwareToggle = id => {
    setForm(prev => {
      const exists = prev.softwareIds.includes(id);

      return {
        ...prev,
        softwareIds: exists
          ? prev.softwareIds.filter(x => x !== id)
          : [...prev.softwareIds, id]
      };
    });
  };

  /* ---------------- UPDATE INSTITUTE ---------------- */

  const handleSave = async () => {
    try {
      await axios.put(
        `${API_BASE}/api/Institutes/${id}`,
        form
      );

      await axios.put(
        `${API_BASE}/api/Institutes/${id}/status?isActive=${form.isActive}`
      );

      alert("Institute updated successfully");
      navigate("/dashboard/institudemng");
    } catch (err) {
      alert(err.response?.data?.message || "Update failed");
    }
  };

  /* ---------------- STATUS TOGGLE ---------------- */

  const toggleStatus = () => {
    setForm(prev => ({
      ...prev,
      isActive: !prev.isActive
    }));
  };

  useEffect(() => {
    const close = e => {
      if (!e.target.closest(".dropdown-wrapper"))
        setDropdownOpen(false);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);


  /* ---------------- UI ---------------- */

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन  &gt;&gt; <span>संस्था संपादन </span>
        </h3>

        <div className="edit-btnn">
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>

          <button className="btn primaryy" onClick={handleSave}>
            सेव्ह करा
          </button>
        </div>
      </div>

      <h2>संस्था संपादन करा</h2>

      <div className="info-gridd">
        <div className="info-boxx">
          <label>संस्थेचे नाव</label>
          <input
            name="instituteName"
            value={form.instituteName}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>मुख्याधापक नाव</label>
          <input
            name="principleName"
            value={form.principleName}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>पत्ता</label>
          <input
            name="address"
            value={form.address}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>ईमेल आयडी</label>
          <input
            name="email"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>संपर्क क्रमांक</label>
          <input
            name="phoneNumber"
            value={form.phoneNumber}
            onChange={handleChange}
          />
        </div>

        <div className="info-boxx">
          <label>शिक्षकांची संख्या</label>
          <input value={teachersCount} disabled />
        </div>

        {/* SOFTWARE MULTI SELECT */}
        <div className="info-boxx">
          <label>परीक्षेचे नाव</label>

          <div className="dropdown-wrapper">
            {/* Dropdown header */}
            <div
              className="dropdown-input"
              onClick={() => setDropdownOpen(prev => !prev)}
            >
              {form.softwareIds.length === 0
                ? "निवडा"
                : `${form.softwareIds.length} निवडले`}
            </div>

            {/* Dropdown list */}
            {dropdownOpen && (
              <ul className="info-list" style={{ listStyle: "none", paddingLeft: 0 }}>
                {allSoftwares.map(s => (
                  <li key={s.id}>
                    <input
                      type="checkbox"
                      checked={form.softwareIds.includes(s.id)}
                      onChange={() => handleSoftwareToggle(s.id)}
                    />
                    {" "}
                    {s.softwareName}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="info-boxx">
          <label>कमिशन टक्केवारी</label>
          <input
            name="commissionPercentage"
            value={form.commissionPercentage}
            onChange={handleChange}
          />
        </div>

        {/* STATUS */}
        <div className="info-boxx">
          <label>स्थिती</label>
          <input
            value={form.isActive ? "सक्रिय" : "निष्क्रिय"}
            readOnly
            onClick={toggleStatus}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
    </div>
  );
};

export default InstitudeEdit;
